var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCloudNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.63 20.83H5.54c-2.94-.21-4.26-2.48-4.26-4.49 0-1.8 1.05-3.8 3.33-4.35-.63-2.52-.08-4.88 1.58-6.59 1.88-1.94 4.87-2.69 7.42-1.86.39.13.61.55.48.94-.13.39-.55.61-.94.48-2.03-.65-4.4-.06-5.89 1.49-1.45 1.5-1.79 3.59-.96 5.9.08.23.05.49-.09.68-.14.19-.37.32-.61.32-1.94.14-2.81 1.6-2.81 2.99 0 1.39.87 2.85 2.81 3h11.04a4.61 4.61 0 0 0 3.13-1.2c1.15-1.01 1.65-2.48 1.4-4.04-.07-.41.21-.79.62-.86.41-.07.79.21.86.62.34 2.06-.37 4.08-1.87 5.4-1.12 1-2.58 1.57-4.11 1.57h-.04z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93 13.68c-.42-.21-.88-.32-1.35-.33a.762.762 0 0 1-.74-.76c.01-.41.4-.75.76-.74.69.01 1.38.18 1.99.49.37.18.52.64.34 1.01a.742.742 0 0 1-1 .33z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22 8.5c0-1.1.42-2.14 1.18-2.92.02-.03.04-.05.06-.07.8-.81 1.86-1.25 3-1.25a4.26 4.26 0 0 1 4.25 4.25c0 1.3-.58 2.51-1.6 3.32-.73.59-1.67.92-2.64.92a4.26 4.26 0 0 1-4.25-4.25zm2.31-1.92c-.52.51-.81 1.2-.81 1.93a2.748 2.748 0 0 0 4.46 2.15c.67-.53 1.04-1.31 1.04-2.15 0-1.52-1.23-2.75-2.75-2.75a2.63 2.63 0 0 0-1.87.74.5.5 0 0 1-.07.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCloudNotif);
export default __webpack_public_path__ + "static/media/vuesax-outline-cloud-notif.50e1d5d96d8a267149543b8025c84d8a.svg";
export { ForwardRef as ReactComponent };